import { swRequest } from "@sourcewhale/core";

export const getCampaign = ({ campaignId }) =>
  swRequest({
    path: "/api/campaigns/get",
    method: "GET",
    params: { campaignId },
  });

export const getCampaigns = ({ currentUserOnly, openOnly }, opts = {}) =>
  swRequest(
    {
      path: "/api/campaigns/get_open",
      method: "GET",
      params: { currentUserOnly, openOnly },
    },
    opts,
  );

export const queryCampaigns = (payload, opts = {}) =>
  swRequest(
    {
      path: "/api/campaigns/query",
      method: "POST",
      body: payload,
    },
    opts,
  );

export const saveCampaign = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/campaigns/save",
      method: "POST",
      body,
    },
    opts,
  );

export const duplicateCampaign = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/campaigns/duplicate",
      method: "POST",
      body,
    },
    opts,
  );

export const spreadsheetMap = (body) =>
  swRequest({ path: "/api/spreadsheet/map", body, method: "POST" });
